import { useState } from "react";
import styles from "./index.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface InstagramModalProps {
  isVisible: boolean;
  onSubmit: (id: string) => void;
}

const InstagramModal = ({ isVisible, onSubmit }: InstagramModalProps) => {
  const [input, setInput] = useState("");

  if (!isVisible) return null;

  return (
    <div className={cx("modalOverlay")}>
      <div className={cx("modalContent")}>
        <h2>🎉 달항아리 달성!</h2>
        <p>인스타그램 아이디를 남겨주세요:</p>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="@your_instagram"
        />
        <button onClick={() => onSubmit(input)}>제출</button>
      </div>
    </div>
  );
};

export default InstagramModal;
